import { createSlice } from '@reduxjs/toolkit';

interface formsState {
    forms_loading: boolean;
    labels: Record<string, any> | null;
    selected_section: Record<string, any> | null;
}

const initialState: formsState = {
    forms_loading: false,
    labels: null,
    selected_section: null
};

export const formsSlice = createSlice({
    name: 'forms',
    initialState,
    reducers: {
        setFormsLoading: (state, action) => {
            state.forms_loading = action.payload;
        },
        setLabels: (state, action) => {
            state.labels = action.payload;
        },
        setSelectedSection: (state, action) => {
            state.selected_section = action.payload;
        },
    },
});

export const {
    setFormsLoading,
    setLabels,
    setSelectedSection
} = formsSlice.actions;

export default formsSlice.reducer;
